import type { App } from 'vue';
import { createRouter, createWebHistory, RouteLocation } from 'vue-router';
import { routes } from '@/plugins/1.router/routes';
import useAppStore from '@/stores/app';

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to: RouteLocation) {
        if (to.hash && document.getElementById(to.hash.substring(1))) {
            return {el: to.hash, behavior: 'smooth', top: 60};
        }

        return {top: 0};
    },
    routes,
});

router.afterEach((to, from, failure) => {
    const appStore = useAppStore();

    if (!appStore.isLoaded && ((typeof to.name !== 'undefined') || (typeof from.name !== 'undefined')) && (to.name !== 'main-layout')) {
        document.querySelector('body')!.classList.remove('overflow-hidden');

        appStore.setLoaded(true);
    }
});

export { router };

export default function (app: App): void {
    app.use(router);
}
